<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadCustomFields(1,null, true)">

      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" @click="addCustomFieldPopup">{{ $t('add_custom_field') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('custom_field_name')" v-model="customFieldSearchParams.name" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <v-select :options="statusOptions" :reduce="label => label.value" :placeholder="$t('status')" v-model="customFieldSearchParams.isActive"/>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadCustomFields(1,null, true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="consultationCustomFieldDataContainer" :title="$t('custom_fields')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-configuration-tab-nav></shared-configuration-tab-nav>
      </template>

      <shared-user-configuration-consultation-custom-field-list
        :customFields="customFields"
        @editCustomFieldPopup="editCustomFieldPopup"
        @deleteCustomField="deleteCustomField"
        @badgeChangeStatus="badgeChangeStatus"
      ></shared-user-configuration-consultation-custom-field-list>

      <template slot="footer">
        <paginate
          :total="customFieldPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadCustomFields"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>

    <modal :title="$t('custom_field_name')" id="addCustomField" :active.sync="modals.add" size="md">
      <shared-consultation-add-custom-field @addCustomFieldSuccess="addCustomFieldSuccess"></shared-consultation-add-custom-field>
      <vs-divider></vs-divider>
      <div class="flex justify-end">
        <vs-button id="addConfigurationConsultationCustomFieldButton" color="primary" type="filled" @click.prevent="addCustomField">{{ $t('save') }}</vs-button>
      </div>
    </modal>

    <modal :title="$t('custom_field_name')" id="editCustomField" :active.sync="modals.edit" size="md">
      <shared-consultation-edit-custom-field @editCustomFieldSuccess="editCustomFieldSuccess"></shared-consultation-edit-custom-field>
      <vs-divider></vs-divider>
      <div class="flex justify-end">
        <vs-button id="updateConfigurationConsultationCustomFieldButton" color="primary" type="filled" @click.prevent="editCustomField">{{ $t('save') }}</vs-button>
      </div>
    </modal>

  </div>
</template>

<script>
import SharedConfigurationTabNav from '@/views/Shared/Configuration/TabNav'
import ConsultationCustomField from '@/models/ConsultationCustomField'
import SharedUserConfigurationConsultationCustomFieldList from '@/views/Shared/Configuration/Consultation/CustomFields/List'
import Paginate from '@/mixins/paginate'
import Modal from '@/components/Modal'
import Utils from '@/helpers/utils'
import { EventBus } from '@/../eventbus'
import SharedConsultationAddCustomField from '@/views/Shared/Configuration/Consultation/CustomFields/Add'
import SharedConsultationEditCustomField from '@/views/Shared/Configuration/Consultation/CustomFields/Edit'
import { statusOptions } from '@/config/options'

export default {
  name: 'User.Configuration.Consultation.CustomFields',
  mixins: [Paginate],
  components: {
    SharedConfigurationTabNav,
    SharedUserConfigurationConsultationCustomFieldList,
    SharedConsultationAddCustomField,
    SharedConsultationEditCustomField,
    Modal
  },
  data () {
    return {
      customFields: {},
      customFieldPages: 1,
      itemPerPage: null,
      customFieldSearchParams: {
        name: typeof this.$route.query.name !== 'undefined' ? this.$route.query.name : '',
        isActive: typeof this.$route.query.isActive !== 'undefined' ? this.$route.query.isActive : ''
      },
      statusOptions,
      modals: {
        add: false,
        edit: false
      }
    }
  },
  watch: {
    'modals.add' (val) {
      if (!val) {
        EventBus.$emit('initAddCustomField')
      }
    }
  },
  mounted () {
    this.$windowOpenerHelper.listenToPopUpMessage('reload_configuration_consultation_custom_field_table', this.loadCustomFields)
    this.loadCustomFields(this.initialPage, null, false, true)
  },
  methods: {
    async loadCustomFields (page = 1, itemPerPage = null, backToPageOne = false, isOnLoad = false) {
      this.$vs.loading({container: '#consultationCustomFieldDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      if (!isOnLoad) {
        this.$router.replace({query: { ...this.customFieldSearchParams, page, itemPerPage }})
      }
      const response = await ConsultationCustomField.all({ ...this.customFieldSearchParams, page, itemPerPage })
      this.customFields = response.data.data.customFields
      this.customFieldPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#consultationCustomFieldDataContainer > .con-vs-loading')
    },
    addCustomField () {
      EventBus.$emit('addNewCustomField')
    },
    addCustomFieldModal () {
      this.modals.add = true
    },
    addCustomFieldPopup () {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'consultation-add-custom-field', {}, this.addCustomFieldModal)
    },
    addCustomFieldSuccess () {
      this.loadCustomFields(1, this.itemPerPage)
      this.modals.add = false
    },
    editCustomField () {
      EventBus.$emit('updateCustomField')
    },
    editCustomFieldModal (data) {
      EventBus.$emit('initEditCustomField', data)
      this.modals.edit = true
    },
    editCustomFieldPopup (id) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'consultation-edit-custom-field', {id}, this.editCustomFieldModal)
    },
    editCustomFieldSuccess () {
      this.loadCustomFields(1, this.itemPerPage)
      this.modals.edit = false
    },
    async deleteCustomField (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })
      if (confirm.value) {
        await ConsultationCustomField.delete(id)
        this.loadCustomFields(1, this.itemPerPage)
      }
    },
    async badgeChangeStatus (key) {
      try {
        if (this.customFields[key].is_active === 1) {
          this.customFields[key].is_active = 0
        } else {
          this.customFields[key].is_active = 1
        }
        await ConsultationCustomField.update(this.customFields[key])
        this.customFields[key].customFieldFormErrors = {}
      } catch (e) {
        this.customFields[key].customFieldFormErrors = e.response.data.errors
      }
    }
  }
}
</script>

<style scoped>

</style>
